<template>
  <div
    v-if="hasItems || hasFilter"
    class="active-filters"
    role="region"
    aria-labelledby="active-filters-label"
  >
    <span
      id="active-filters-label"
      class="active-filters__label"
    >
      Deine Filter:
    </span>
    <ul
      class="active-filters__list"
      aria-label="Aktive Filter"
    >
      <li
        v-for="(item, key) in items"
        :key="key"
        class="active-filters__item"
      >
        <FilterTag
          v-bind="item"
          @click="remove"
        />
      </li>
      <li class="active-filters__clear">
        <LinkButton
          tag="button"
          type="button"
          text
          class="active-filters__clear-button"
          @click="clear"
        >
          Alle Filter löschen
        </LinkButton>
      </li>
    </ul>
  </div>
</template>

<script>
import { cloneDeep, isEqual, remove } from 'lodash-es';
import FilterTag from '@/components/filter/filter-tag.vue';
import { LinkButton } from '@i22-td-smarthome/component-library';

export default {
  name: 'ActiveFilters',
  components: {
    LinkButton,
    FilterTag,
  },
  props: {
    hasFilter: {
      type: Boolean,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['remove', 'clear'],
  data() {
    return {
      items: cloneDeep(this.value),
    };
  },
  computed: {
    hasItems() {
      return this.items.length > 0;
    },
  },
  watch: {
    value(value) {
      this.items = value;
    },
  },
  methods: {
    clear() {
      const prevItems = this.items;
      this.items = [];
      this.$emit('clear', prevItems);
    },
    remove(value) {
      remove(this.items, (itemValue) => isEqual(itemValue.value, value));
      this.$emit('remove', value);
    },
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.active-filters {
  user-select: none;
  margin: $grid-base 0;

  &__label {
    display: inline-block;
    margin-right: 10px;
    font-weight: 700;
    width: 100%;
    margin-bottom: 0.5rem;
    font-size: inherit;

    @include mq($mq-sm) {
      width: auto;
      margin-bottom: 0;
    }
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: inline;

    @include mq($mq-sm) {
      display: inline;
    }
  }

  &__item {
    display: inline-block;
    margin-left: 0;
    margin-right: 10px;
    padding-bottom: 6px;
  }

  &__clear {
    display: block;
    padding-top: 6px;
    margin-left: 0;
    @include mq($mq-sm) {
      padding: 0;
      display: inline-block;
    }

    &-button {
      @include font-size(15px, 18px);
    }
  }
}
</style>
